import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export default () => (
	<Switch>
		<Route path="/admin/fractions" exact component={List} />
		<Route path="/admin/fractions/create" component={Edit} />
		<Route path="/admin/fractions/:id" component={Edit} />
	</Switch>
);
